module.exports = __webpack_public_path__ + "img/supplySolutions3.38c387bb.png";